var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notes_content_body"},[_c('div',{staticClass:"notes_editor_container"},[_c('input',{staticClass:"note_title_input readonly",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.noteDetails.title}}),_c('div',{staticClass:"readonly_content_area",domProps:{"innerHTML":_vm._s(_vm.noteDetails.data)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }